const Vendor = {

    // FIELDS
    "name": "الاسم",
    "address": "العنوان",
    "postal_code": "الرمز البريدي",
    "pan_no": "رقم البطاقة الضريبية",
    "tin_no": "رقم الضريبة على القيمة المضافة",
    "longitude": "خط الطول",
    "latitude": "خط العرض",
    "city": "المدينة",
    "status": "الحالة",
    "search": "البحث",

    // PAGE HEADER
    "vendor": "البائع",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_address": "الرجاء إدخال العنوان",
    "error_postal_code": "الرجاء إدخال الرمز البريدي",
    "error_pan_no": "الرجاء إدخال رقم البطاقة الضريبية",
    "error_tin_no": "الرجاء إدخال رقم الضريبة على القيمة المضافة",
    "error_longitude": "الرجاء إدخال خط الطول",
    "error_latitude": "الرجاء إدخال خط العرض",
    "error_city": "الرجاء اختيار المدينة",
    "error_status": "الرجاء اختيار الحالة",
    "error_type_error": "الرجاء إدخال رقم صحيح فقط",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_address": "العنوان",
    "table_city": "المدينة",
    "table_status": "الحالة",
}

export default Vendor;
